'use strict';

$(document).ready(function () {
    var $carousel = $('.carousel') ;
    var gCurrentSlide;
    var gPrevSlide = 0;
    $carousel.on('beforeChange', function (slick, currentSlide, prevSlide){
        gCurrentSlide = currentSlide;
        gPrevSlide = prevSlide;
    });

    $carousel.on('afterChange', function (slick, slide){
        var isProductType = $(this).hasClass('product-carousel');
        var decl = slide.currentSlide - gPrevSlide;
        if (decl == 1 || (decl == -2 && slide.slideCount - 1 == gPrevSlide)) {
            $carousel.addClass('is-prev');
            if (isProductType) {
                if (slide.currentSlide !== slide.slideCount - 1) {
                    $('.slick-list')
                        .addClass('pad-left')
                        .removeClass('pad-right');
                } else {
                    $('.slick-list')
                        .addClass('pad-right')
                        .removeClass('pad-left');
                }
            } else {
                $('.slick-list')
                    .addClass('pad-left')
                    .removeClass('pad-right');
            }
        } else {
            $carousel.addClass('is-next');
            if (isProductType) {
                if (slide.currentSlide !== 0) {
                    $('.slick-list')
                        .addClass('pad-right')
                        .removeClass('pad-left');
                } else {
                    $('.slick-list')
                        .addClass('pad-left')
                        .removeClass('pad-right');
                }
            } else {
                $('.slick-list')
                    .addClass('pad-right')
                    .removeClass('pad-left');
            }
        }

    });

    $carousel.on('afterChange', function(){
        $carousel.removeClass('is-prev').removeClass('is-next');
    });
});
